import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, AbstractControlOptions, AsyncValidator, FormArray, FormControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { typeFormRequestEnum } from 'src/app/Enums/TypeFormRequestEnum';
import { subjectRequestFormEnum } from 'src/app/Enums/subjectRequestFormsEnum';
import { GlobalService } from 'src/app/app-core/lib/global.service';
import { EvaluationTermService } from 'src/app/app-core/services/evaluation-term.service';
import { OrganizationService } from 'src/app/app-core/services/organization.service';
import { SubjectAttachmentService } from 'src/app/app-core/services/subject-attachment.service';
import { SubjectService } from 'src/app/app-core/services/subject.service';
import { TagsService } from 'src/app/app-core/services/tags.service';
import { UserService } from 'src/app/app-core/services/user.service';
import { IListScopeOrganizationResponse } from 'src/app/interfaces/listScope/listScopeOrganizationResponse';
import { IListScopeSubjectResponse } from 'src/app/interfaces/listScope/listScopeSubjectResponse';
import { GenericValidator } from 'src/app/app-core/modules/forms/utilities/genericValidator';
import { subjectsTypeEnum } from 'src/app/Enums/subjectsEnum';
import { typeProcessEnum } from 'src/app/Enums/typeProcessEnum';
import { OversightOrganizationService } from 'src/app/app-core/services/oversight-organization.service';
import { catchError, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable, forkJoin } from 'rxjs';
import { SubjectAcceptSignEnum } from 'src/app/Enums/subjectAcceptSignEnum';
import { concatMap } from 'rxjs/operators';
import { FiscoService } from 'src/app/app-core/services/fisco.service';
import { of } from 'rxjs';
import { UserDataRequestService } from 'src/app/app-core/services/user-data-request.service';
import { LocalStorageService } from 'src/app/app-core/services/local-storage.service';
import { MessageService } from 'primeng/api';
import { DigitalFormService } from 'src/app/app-core/services/digital-form.service';
import { IDigitalForm } from 'src/app/interfaces/digital-form';
import { RequestService } from 'src/app/app-core/services/request.service';
import { IServiceCatalogItem } from 'src/app/interfaces/request-ui';
import { orgIcon } from 'src/app/app-core/lib/request-status';
import { phoneMask } from 'src/app/app-core/lib/phone-mask';

enum TypePersonRequestEnum {
    JURIDICA = 1,
    FISICA = 2
}

enum tipoInscricaoEnum {
    JURIDICO = 1,
    FISICO = 2,
    ORGAO_FISCALIZADORES = 3
}

/** Grupo de serviços do catálogo: um órgão, ou o resultado de uma busca. */
interface IServiceGroup {
    key: string;
    title: string;
    items: IServiceCatalogItem[];
}

/** Quantos serviços aparecem em "Mais solicitados". */
const POPULAR_SERVICES = 6;

/** Quantos serviços de cada órgão aparecem antes do "Ver os N serviços". */
const GROUP_PREVIEW = 5;

/**
 * "SECRETARIA MUNICIPAL DE EDUCAÇÃO" → "EDUCAÇÃO"; "SECRETARIA DE FINANÇAS, PLANEJAMENTO
 * E ORÇAMENTO" → "FINANÇAS". Sigla não diz nada a quem não trabalha na Prefeitura.
 */
function orgaoCurto(descricao: string): string {
    return String(descricao || '')
        .replace(/^SECRETARIA\s+(MUNICIPAL\s+)?(DE|DA|DO|DAS|DOS)\s+/i, '')
        .split(',')[0]
        .trim();
}

@Component({
    selector: 'app-user-data-request',
    templateUrl: './user-data-request.component.html',
    styleUrls: ['./user-data-request.component.scss'],
    providers: [OrganizationService, EvaluationTermService, UserService, SubjectService, TagsService, FiscoService, OversightOrganizationService, LocalStorageService, MessageService, DigitalFormService]
})
export class UserDataRequestComponent implements OnInit {
    /**
     * A mesma instância atende duas etapas da solicitação: a escolha do serviço e o
     * "para quem". O formulário é um só; aqui só se escolhe o que mostrar.
     */
    @Input() view: 'service' | 'applicant' = 'service';

    public user;
    public form: FormGroup;
    public isDisabled = true;
    public entity;
    public requiredFields;
    public triagemTermo;
    public modalName = 'solicitacao-sucesso';
    public subjects = [];
    public attachments = [];
    public mimeTypes: string[] = ['application/pdf'];
    public organizations = [];
    public orgao: any;
    public subjectName: string;
    public subjectFormLink: string;
    public subjectGuidelinesLink: string;
    public typeForm: number;
    /** Formulário digital ativo do assunto. Quando existe, tem precedência sobre os modelos fixos. */
    public digitalForm: IDigitalForm | null = null;
    public orgaoOnlySubject = [];
    public procuracao = [];
    public procuracaoDraftFiles: any[] = [];
    public cpfCnpjMask: string;
    public isOrgaoDisabled: boolean = false;
    public telefoneMask: string;
    public showTipoRepresentante: boolean = false;
    public showOrgaoFiscalizador: boolean = false;
    public cnpjOrgaoFiscalizador: string;
    public procuradoriaCodigo: number;
    public listOrganizations: string;

    public haveSign = false;
    public isOrgaoFiscalizador = false;
    public subjectDepartmentCode;
    
    protected dialogRefisVisible = false;
    protected textCheckboxRepresentationPerson = "QUERO REPRESENTAR UMA PESSOA FÍSICA OU JURÍDICA"

    private subjectRequestRefis = "SOLICITAÇÃO DE ADESÃO AO REFIS";
    private termScreeningAccepted: boolean = false;
    private listSubjectsAcceptsSign: string[] = Object.values(SubjectAcceptSignEnum);
    public isChecked: boolean = false;

    @Output() subjectChanged = new EventEmitter<void>();

    private storedSolicitacaoDraft: any;
    private storedRequerenteDraft: any;
    private storedProcuracaoDraft: any;
    private storedCheckAnotherApplicant: boolean | null;
    public filteredRepresentativeOptions: any[] = [];

    // CATÁLOGO DE SERVIÇOS
    public catalog: IServiceCatalogItem[] = [];
    public catalogLoading = true;
    public catalogError = false;
    public catalogQuery = '';
    /** Filtro por órgão; null = todos. */
    public catalogOrgao: number | null = null;
    public catalogOrgaos: Array<{ id: number; sigla: string; nome: string; descricao: string; total: number }> = [];
    public catalogGroups: IServiceGroup[] = [];
    public catalogResultCount = 0;
    public popularServices: IServiceCatalogItem[] = [];
    /** Órgãos com a lista aberta além da prévia (ver GROUP_PREVIEW). */
    public expandedGroups: Record<string, boolean> = {};
    public readonly groupPreview = GROUP_PREVIEW;
    public readonly phoneMask = phoneMask;
    /** Com um serviço já escolhido, a lista volta a aparecer quando o cidadão quer trocar. */
    public changingService = false;
    /** O assunto escolhido ainda está carregando (formulário, anexos, assinatura). */
    public loadingSubject = false;

    constructor(
        public global: GlobalService,
        public userService: UserService,
        public evaluationTermService: EvaluationTermService,
        public organizationService: OrganizationService,
        public subjectService: SubjectService,
        public subjectAttachmentService: SubjectAttachmentService,
        public tagsService: TagsService,
        public oversightOrganizationService: OversightOrganizationService,
        private fb: FormBuilder,
        private fiscoService: FiscoService,
        private userDataRequestService: UserDataRequestService,
        private localStorageService: LocalStorageService,
        private messageService: MessageService,
        private digitalFormService: DigitalFormService,
        private requestService: RequestService
    ) {
        this.user = this.global.user();
        this.initForm();
        this.readStoredDraft();
        this.watchSubjectChanges();
        this.listOrgaos();
        this.loadCatalog();
    }

    /**
     * Carrega o assunto sempre que o controle muda, e não só no clique do dropdown: um
     * valor restaurado por código (o rascunho da solicitação, por exemplo) também precisa
     * trazer o formulário digital, o tipo de formulário e a exigência de assinatura.
     * Registrado no construtor para já valer antes de qualquer restauração no ngOnInit.
     */
    private watchSubjectChanges(): void {
        this.solicitacaoFormGroup.get('SOL_CodigoAssunto').valueChanges
            .pipe(distinctUntilChanged())
            .subscribe((subjectId) => {
                if (subjectId) {
                    this.setSubjectNameAndAttachments();
                }
            });
    }

    ngOnInit(): void {
        this.requerenteFormGroup.get('SOLR_TipoInscricao')?.valueChanges.subscribe(value => {
            this.updateMask();
            this.isOrgaoFiscalizador = (value == tipoInscricaoEnum.ORGAO_FISCALIZADORES);
            this.form.value.applicantRequest = true;
            this.filterRepresentativeOptions();
            this.validatorTermoCiente();
        });

        this.verifyRulesForUserTriagem();
        this.applyStoredDraft();
        this.selectDynamicPgm();
        this.changesOrgaoFiscalizacao();
        this.listOrganAndSubjects();
        this.watchRequerenteChanges();

        this.form.get('applicantRequest')?.valueChanges.subscribe(value => {
            this.userDataRequestService.setRepresentingAnotherPerson(value);
        });

        this.isChecked = this.hasLocalStorageField()

        this.updateCheckboxState();
        this.solicitacaoFormGroup.get('SOL_CodigoAssunto')?.valueChanges.subscribe(() => {
            this.filterRepresentativeOptions();
            this.validatorTermoCiente();
        });

        this.requerenteFormGroup.get('SOLR_TipoRepresentante')?.valueChanges.subscribe(() => {
            this.validatorTermoCiente();
        });

        this.requerenteFormGroup.valueChanges.subscribe(value => {
            this.userDataRequestService.setRepresentativeData(value);
        });
    }


    private filterRepresentativeOptions(): void {
        const isJuridica = this.requerenteFormGroup.get('SOLR_TipoInscricao')?.value == TypePersonRequestEnum.JURIDICA;
        const assuntoId = this.solicitacaoFormGroup.get('SOL_CodigoAssunto')?.value;
        
        const isAssuntoDTI = this.isAssuntoDTI(assuntoId);

        if (isJuridica && isAssuntoDTI) {
            this.filteredRepresentativeOptions = [
                { value: 'PROCURADOR', label: 'PROCURADOR' }
            ];
        } else {
            this.filteredRepresentativeOptions = [
                { value: 'SÓCIO', label: 'SÓCIO' },
                { value: 'PROCURADOR', label: 'PROCURADOR' },
                { value: 'ADMINISTRADOR', label: 'ADMINISTRADOR' },
                { value: 'RESPONSÁVEL LEGAL', label: 'RESPONSÁVEL LEGAL' }
            ];
        }

        const currentValue = this.requerenteFormGroup.get('SOLR_TipoRepresentante')?.value;
        if (currentValue && !this.filteredRepresentativeOptions.some(opt => opt.value === currentValue)) {
            this.requerenteFormGroup.get('SOLR_TipoRepresentante')?.setValue(null);
        }
    }

    private isAssuntoDTI(assuntoId: number): boolean {
        const assunto = this.subjects.find(s => s.AS_CodigoAssunto === assuntoId);
        return assunto && assunto.AS_Descricao.includes('DTI');
    }

    public shouldShowTermoCiente(): boolean {
        const assuntoId = this.solicitacaoFormGroup.get('SOL_CodigoAssunto')?.value;
        const tipoPessoa = this.requerenteFormGroup.get('SOLR_TipoInscricao')?.value;
        
        return this.isAssuntoDTI(assuntoId) && tipoPessoa == TypePersonRequestEnum.JURIDICA;
    }

    public get requerenteFormGroup() {
        return this.form.get('requerente');
    }

    public get solicitacaoFormGroup() {
        return this.form.get('solicitacao');
    }

    public get procuracaoFormGroup() {
        return this.form.get('procuracao');
    }

    private changesOrgaoFiscalizacao(): void {
        const requerenteForm = this.form.get("requerente");
        const solrCpfCnpjControl = requerenteForm.get("SOLR_CpfCnpj");
        const solrTipoInscricaoControl = requerenteForm.get("SOLR_TipoInscricao");
    
        solrCpfCnpjControl.valueChanges.subscribe((cpfCnpjValue: string) => {
            const orgaoFiscalizacao = solrTipoInscricaoControl.value;
            
            if (orgaoFiscalizacao == 3 && cpfCnpjValue) {
                this.oversightOrganizationService.getCnpjOrgaoFiscalizador(cpfCnpjValue).subscribe({
                    next: (response: any) => {
                        if (response.ORFI_Cnpj) {
                            requerenteForm.get("SOLR_TipoInscricao").setErrors(null); 
                        }
                        else {
                            requerenteForm.get("SOLR_TipoInscricao").setErrors({ invalidCnpj: true });
                        }        

                        this.form.updateValueAndValidity();
                    },
                    error: (err) => {
                        requerenteForm.get("SOLR_TipoInscricao").setErrors({ invalidCnpj: true });
                        this.form.updateValueAndValidity();
                    }
                });
            }
            else {
                requerenteForm.get("SOLR_TipoInscricao").setErrors(null);
                this.form.updateValueAndValidity();
            }
        });
    }

    public saveOnLocalStorage() {
        this.localStorageService.set('user-data-solicitacao', this.solicitacaoFormGroup!.getRawValue());
        this.localStorageService.set('user-data-requerente', this.requerenteFormGroup!.getRawValue());
        this.localStorageService.set('user-data-procuracao', this.procuracaoFormGroup!.getRawValue());
        this.localStorageService.set('user-data-check-another-applicant', this.form.get('checkAnotherApplicant')!.value);
    }

    public clearLocalStorage() {
        this.localStorageService.remove('user-data-solicitacao');
        this.localStorageService.remove('user-data-requerente');
        this.localStorageService.remove('user-data-procuracao');
        this.localStorageService.remove('user-data-check-another-applicant');
    }

    private readStoredDraft() {
        this.storedSolicitacaoDraft = this.localStorageService.get<any>('user-data-solicitacao');
        this.storedRequerenteDraft = this.localStorageService.get<any>('user-data-requerente');
        this.storedProcuracaoDraft = this.localStorageService.get<any>('user-data-procuracao');
        this.storedCheckAnotherApplicant = this.localStorageService.get<boolean>('user-data-check-another-applicant');
    }

    private applyStoredDraft() {
        if (this.storedSolicitacaoDraft && typeof this.storedSolicitacaoDraft === 'object') {
            this.form.get('solicitacao')?.patchValue(this.storedSolicitacaoDraft);

            if(this.form.value.solicitacao.SOL_CodigoOrgao) {
                this.listAssuntoByOrgao(this.form.value.solicitacao.SOL_CodigoOrgao);
            }

            if (this.storedRequerenteDraft && typeof this.storedRequerenteDraft === 'object') {
                this.form.get('requerente')?.patchValue(this.storedRequerenteDraft);
            }

            if (Array.isArray(this.storedProcuracaoDraft) && this.storedProcuracaoDraft.length) {
                // patchValue não cria controles em FormArray vazio, então recria um por arquivo
                const procuracaoArray = this.form.get('procuracao') as FormArray;
                procuracaoArray.clear();
                this.storedProcuracaoDraft.forEach(file => procuracaoArray.push(this.fb.control(file)));

                // formato esperado pelo input [files] do dropzone
                this.procuracaoDraftFiles = this.storedProcuracaoDraft.map(file => ({
                    SOLA_Nome: file.name,
                    SOLA_Anexo: file.url,
                }));
            }

            setTimeout(() => {
                this.messageService.add({
                    severity: 'info',
                    summary: 'Rascunho recuperado',
                    detail: 'Continue de onde você parou.',
                    life: 4000,
                });
            });
        }
    }

   private hasLocalStorageField() {
        return this.storedCheckAnotherApplicant === true;
    }

    updateCheckboxState(): void {
        const checkboxControl = this.form.get('checkAnotherApplicant');
        
        if (!checkboxControl) return;

        const deveMarcar = this.userService.isTriagem() || (this.isSemurb && this.isChecked === false) || this.isChecked;
        
        checkboxControl.setValue(deveMarcar);
        if(deveMarcar) {
            this.isDisabled = false;
            this.updateMask();
        } 
        if(!deveMarcar) this.isDisabled = true;

        if (this.userService.isTriagem()) {
            checkboxControl.disable();
        } else {
            checkboxControl.enable();
        }
    }

    private initForm() {
        const codigoOrgao = this.userService.isTriagem() ? this.user.USR_CodigoOrgao : null;
        this.isOrgaoDisabled = this.userService.isTriagem();

        const formOptionsProcess: AbstractControlOptions = {
            validators: [this.validatorRuleProcuracao],
        };
        const validateTelefone = (!this.user.PE_Telefone1 && !this.userService.isTriagem()) ? Validators.required : null;

        this.form = this.fb.group({
            subject: [null],
            applicantRequest: [false],
            PE_Telefone: [null, validateTelefone],
            solicitacao: this.fb.group({
                SOL_CodigoOrgao: [codigoOrgao, Validators.required],
                SOL_CodigoAssunto: [null, Validators.required],
                SOL_CodigoSolicitante: [this.user.USR_CodigoPessoa, Validators.required],
                SOL_Status: 0,
                SOLR_TipoInscricao: [''],
                SOL_CodigoDocumento: null,
                SOLH_Historico: ['A solicitação está em análise'],
            }),
            requerente: this.fb.group({
                SOLR_TipoInscricao: ['2'],
                SOLR_CpfCnpj: [this.user.PE_CPF],
                SOLR_NomeRazaoSocial: [this.user.PE_Nome],
                SOLR_Email: [this.user.PE_Email],
                SOLR_Telefone: [this.user.PE_Telefone1],
                SOLR_TipoRepresentante: [null],
                SOLR_TipoOrgaoFiscalizador: [null]
            }),
            procuracao: this.fb.array([]),
            isTriagem: [this.userService.isTriagem()],
            checkAnotherApplicant: [this.userService.isTriagem() ? true : false],
            refisPeriod: [false],
            termoCiente: [false]
        }, 
            formOptionsProcess
        );

        if (this.userService.isTriagem() && codigoOrgao) {
            this.form.get('solicitacao.SOL_CodigoOrgao').disable();
            this.listAssuntoByOrgao(codigoOrgao);
        }
    }

    private validatorTermoCiente(): void {
        const termoControl = this.form.get("termoCiente");
        const assuntoId = this.solicitacaoFormGroup.get("SOL_CodigoAssunto")?.value;
        const tipoPessoa = this.requerenteFormGroup.get("SOLR_TipoInscricao")?.value;
        const tipoRepresentante = this.requerenteFormGroup.get("SOLR_TipoRepresentante")?.value;
      
        const isAssuntoDTI = this.isAssuntoDTI(assuntoId);
      
        const precisaTermo =
          isAssuntoDTI &&
          tipoPessoa == TypePersonRequestEnum.JURIDICA &&
          tipoRepresentante === "PROCURADOR";
      
        if (precisaTermo) {
          termoControl.setValidators(Validators.requiredTrue);
        } else {
          termoControl.clearValidators();
          termoControl.setValue(false, { emitEvent: false });
        }
      
        termoControl.updateValueAndValidity({ emitEvent: false });
    }      

    private watchRequerenteChanges() {
        const checkAnotherApplicantControl = this.form.get('checkAnotherApplicant');

        checkAnotherApplicantControl?.valueChanges.subscribe((isAnotherApplicant: boolean) => {
            this.userDataRequestService.setRepresentingAnotherPerson(isAnotherApplicant);
            this.userDataRequestService.setRequerente(this.requerenteFormGroup.getRawValue());

            this.saveOnLocalStorage();
        });

        this.requerenteFormGroup.valueChanges.subscribe(() => {
            this.userDataRequestService.setRequerente(this.requerenteFormGroup.getRawValue());
        });
    }

    public updateMask() {
        this.saveOnLocalStorage();
        const tipoInscricao = this.requerenteFormGroup.get('SOLR_TipoInscricao')?.value;
        this.showTipoRepresentante = tipoInscricao === '1';
        this.showOrgaoFiscalizador = tipoInscricao === '3';

        if (tipoInscricao == 1) {
            this.requerenteFormGroup.get('SOLR_TipoRepresentante')?.setValidators(Validators.required);
            this.requerenteFormGroup.get('SOLR_TipoRepresentante')?.updateValueAndValidity();
            this.cpfCnpjMask = '00.000.000/0000-00';
        }
        else if (tipoInscricao == 2) {
            this.requerenteFormGroup.get('SOLR_TipoRepresentante')?.setValue(null, { emitEvent: false });
            this.requerenteFormGroup.get('SOLR_TipoRepresentante')?.setValidators(null);
            this.requerenteFormGroup.get('SOLR_TipoRepresentante')?.updateValueAndValidity();
            this.cpfCnpjMask = '000.000.000-00';
        }
        else if (tipoInscricao == 3) {
            this.cpfCnpjMask = '00.000.000/0000-00'; 
        }
    }

    public toggleActiveFields() {
        const requerenteFields = [
            'requerente.SOLR_CpfCnpj',
            'requerente.SOLR_NomeRazaoSocial',
            'requerente.SOLR_Email',
            'requerente.SOLR_Telefone',
        ];

        if (this.isDisabled) {
            this.form.get('applicantRequest').patchValue(true);
            this.setRequerenteFields([
                {
                    name: "SOLR_TipoInscricao",
                    value: null,
                    addvalidators: [Validators.required]
                },
                {
                    name: "SOLR_CpfCnpj",
                    value: null,
                    addvalidators: [Validators.required, GenericValidator.isValidCpfOrCnpj()]
                },
                {
                    name: "SOLR_NomeRazaoSocial",
                    value: null,
                    addvalidators: [Validators.required]
                },
                {
                    name: "SOLR_Email",
                    value: null,
                    addvalidators: [GenericValidator.emailValidator()]
                },
                {
                    name: "SOLR_Telefone",
                    value: null,
                    addvalidators: this.userService.isTriagem() ? [] : [Validators.required]
                }
            ]);
            this.toggleFields(false, requerenteFields);

            this.form.get('requerente.SOLR_TipoInscricao').valueChanges.subscribe(value => {
                this.toggleFields(!!value, requerenteFields);
            });

            if (this.global.user().USR_Administrador || this.userService.isTriagem()) {
                this.checkIsAcceptedTriagemTermo();
            }

            this.form.get('termoCiente').setValidators(Validators.requiredTrue);
            this.form.get('termoCiente').enable();
        }
        else {
            this.form.get('applicantRequest').patchValue(false);
            this.setRequerenteFields([
                {
                    name: "SOLR_TipoInscricao",
                    value: "2",
                    removeValidators: [Validators.required]
                },
                {
                    name: "SOLR_CpfCnpj",
                    value: this.user.PE_CPF,
                    removeValidators: [Validators.required]
                },
                {
                    name: "SOLR_NomeRazaoSocial",
                    value: this.user.PE_Nome,
                    removeValidators: [Validators.required]
                },
                {
                    name: "SOLR_Email",
                    value: this.user.PE_Email,
                    removeValidators: [Validators.required]
                },
                {
                    name: "SOLR_Telefone",
                    value: this.user.PE_Telefone1,
                    addvalidators: this.userService.isTriagem() ? [] : [Validators.required]
                }
            ]);
            this.toggleFields(false, requerenteFields);

            this.form.get('termoCiente').clearValidators();
            this.form.get('termoCiente').setValue(false);
            this.form.get('termoCiente').disable();
        }
        this.saveOnLocalStorage();
        this.isDisabled = !this.isDisabled;
        this.form.get('termoCiente').updateValueAndValidity();
    }

    public getUploadedFile(event) {
        const procuracaoArray = this.form.get('procuracao') as FormArray;
        procuracaoArray.push(this.fb.control(event.file)); 
        this.saveOnLocalStorage();
    }

    public onDeleteFileUploaded(event) {
        (this.form.get("procuracao") as FormArray).removeAt(event.index);
        this.saveOnLocalStorage();
    }

    public checkIsAcceptedTriagemTermo() {
        const userId = parseInt(this.global.user().USR_CodigoUsuario);

        this.evaluationTermService.listAll(`"TT_CodigoUsuario" = ${userId}`).subscribe({
            next: (response: any) => {
                this.triagemTermo = response.data;

                if (this.triagemTermo.length == 0) {
                    this.global.showModalInfo(this.modalName + '-termo');
                } else {
                    this.termScreeningAccepted = true;
                }
            },
        });
    }

    /** @param afterLoad executado com as regras do órgão já aplicadas (ver selectService). */
    public setOrgaoNameAndForm(id: number, afterLoad?: () => void) {
        this.organizationService.getEntity(id).subscribe({
            next: (response: any) => {
                this.orgao = response.entity.orgao;

                if (this.isSead) {
                    this.typeForm = typeFormRequestEnum.SEAD;
                }

                if (this.isSemurb) {
                    this.typeForm = typeFormRequestEnum.SEMURB;

                    if (!this.form.get('checkAnotherApplicant')?.value) {
                        this.toggleActiveFields();
                    }
                }

                afterLoad?.();
            },
        });
    }

    public listAssuntoByOrgao(id: number, afterLoad?: () => void) {
        this.subjectService.listAll(`"AS_Status" = ${true} AND "AS_CodigoOrgao" = ${id} AND ("AS_TipoProcesso" = ${subjectsTypeEnum.EXTERNO} OR "AS_TipoProcesso" = ${subjectsTypeEnum.INTERNO_EXTERNO})`, 0).subscribe({
            next: (response: IListScopeSubjectResponse) => {
                this.subjects = response.data
            },
        });
        
        this.setOrgaoNameAndForm(id, afterLoad);
        this.isChecked = false;
        this.updateCheckboxState();
    }

    // disparado só pela troca manual no dropdown; a restauração do rascunho não passa por aqui.
    // Só descarta os documentos: quem carrega o assunto, nos dois casos, é o watchSubjectChanges.
    public onSubjectChange() {
        this.subjectChanged.emit();
    }

    public setSubjectNameAndAttachments() {
        const subjectId = this.solicitacaoFormGroup.get('SOL_CodigoAssunto').value;

        this.global.startLoading();
        this.loadingSubject = true;

        forkJoin({
            subject: this.subjectService.getEntity(subjectId),
            digital: this.digitalFormService.getBySubject(subjectId).pipe(
                catchError(() => of({ ok: false, formulario: null })),
            ),
        }).pipe(
            concatMap(({ subject, digital }: any) => {
                // Resposta de um assunto que já foi trocado: a do atual está a caminho.
                if (Number(this.solicitacaoFormGroup.get('SOL_CodigoAssunto').value) !== Number(subjectId)) {
                    return of(null);
                }

                const response: any = subject;
                const entity = response.entity;

                // A triagem não preenche o formulário digital: o requerimento seria gerado e
                // assinado em nome dela. Ela segue o caminho de sempre e anexa o requerimento
                // (o modelo continua no "Link do formulário físico" do assunto).
                this.digitalForm = this.userService.isTriagem() ? null : digital?.formulario || null;
                this.attachments = entity.attachments;
                this.subjectName = entity.AS_Descricao;
                this.subjectFormLink = entity.AS_LinkFormulario;
                this.subjectGuidelinesLink = entity.AS_LinkDiretrizes;
                this.subjectDepartmentCode = entity.AS_CodigoDepartamento;

                const normalizeString = (str: string) =>
                  str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "").toLowerCase();
            
                const subjectExistInList = this.listSubjectsAcceptsSign
                    .map(normalizeString)
                    .includes(normalizeString(this.subjectName));

                const hasForm = !!entity.AS_FormDigital === true;

                this.haveSign = !this.userService.isTriagem() && (
                    subjectExistInList ||
                    (this.isSemurb && hasForm)
                );

                if (this.isSemurb) {
                    this.typeForm = entity.AS_FormDigital === true
                        ? typeFormRequestEnum.SEMURB
                        : null;
                }
                else if (this.isSead) {
                    this.typeForm = typeFormRequestEnum.SEAD;
                }
                else {
                    if (entity.AS_CodigoTag) {
                        this.typeFormRequest(entity.AS_CodigoTag, subjectId);
                    }
                    else if (this.subjectName === subjectRequestFormEnum.INSCRICAO_MUNICIPAL) {
                        this.typeForm = typeFormRequestEnum.INSCRICAO;
                    }
                    else if (
                        this.subjectName === subjectRequestFormEnum.SOLICITACAO_ALTERACAO_CADASTRAL_REGULARIZACAO_ALVARA ||
                        this.subjectName === subjectRequestFormEnum.SOLICITACAO_INSCRICAO_MUNICIPAL_EXPEDICAO_ALVARA
                    ) {
                        this.typeForm = typeFormRequestEnum.ALVARA;
                    }
                    else {
                        this.typeForm = null;
                    }
                }

                // Precedência: havendo formulário digital criado pelo administrador,
                // ele substitui qualquer modelo fixo resolvido acima. A assinatura do
                // cidadão é sempre exigida nesse caminho.
                if (this.digitalForm) {
                    this.typeForm = typeFormRequestEnum.DINAMICO;
                    this.haveSign = !this.userService.isTriagem();
                }

                if (this.subjectName === this.subjectRequestRefis) {
                    this.refisControl.setValidators(Validators.requiredTrue);
                    this.form.updateValueAndValidity();

                    return this.fiscoService.verificarPeriodoRefis();
                }
                else {
                    this.refisControl.clearValidators();
                    this.refisControl.setValue(false);
                    this.refisControl.updateValueAndValidity();
                }

                return of(null);
            })
        ).subscribe({
            next: (refisPeriod: boolean | null) => {
                if (typeof refisPeriod === 'boolean') {
                    this.refisControl.setValue(refisPeriod);
                    if (!refisPeriod) {
                        this.dialogRefisVisible = true;
                    }
                    this.userDataRequestService.addValueRefisPeriodActive(refisPeriod);
                }
            },
            complete: () => {
                this.loadingSubject = false;
                this.global.stopLoading();
                this.saveOnLocalStorage();
            },
            error: (err) => {
                console.error(err);
                this.loadingSubject = false;
                this.global.stopLoading();
            }
        });
    }

    private listOrgaos() {
        this.organizationService.listAll(`"OR_TipoProcessoAceito" = ${typeProcessEnum.INTERNO_EXTERNO} OR "OR_TipoProcessoAceito" = ${typeProcessEnum.EXTERNO}`, 0).subscribe({
            next: (response: IListScopeOrganizationResponse) => {
                this.organizations = response.data;
            }
        });
    }

    private setRequerenteFields(fields: { name: string, value: any, addvalidators?: any[], removeValidators?: any[] }[]) {
        for (const field of fields) {
            this.requerenteFormGroup.get(field.name).setValue(field.value);
            this.requerenteFormGroup.get(field.name).setValidators(field.addvalidators);
            this.requerenteFormGroup.get(field.name).removeValidators(field.removeValidators);
        }
    }

    /**
     * Tipo do formulário fixo pela tag do assunto (IPTU, ITBI). A resposta chega depois
     * do restante do assunto: se ele tem formulário digital, ou se o cidadão já trocou
     * de assunto, ela é descartada — antes sobrescrevia o DINAMICO e o PDF do IPTU era
     * montado com as respostas do formulário digital, deixando a assinatura em branco.
     */
    public typeFormRequest(codigoTag: number, subjectId?: number) {
        this.tagsService.getEntity(codigoTag).subscribe({
            next: (response: any) => {
                const assuntoAtual = this.solicitacaoFormGroup.get('SOL_CodigoAssunto').value;

                if (this.digitalForm || (subjectId && Number(assuntoAtual) !== Number(subjectId))) return;

                switch (response.entity.TAG_Nome) {
                    case 'IPTU':
                        this.typeForm = typeFormRequestEnum.IPTU;
                        break;
                    case 'ITBI':
                        this.typeForm = typeFormRequestEnum.ITBI;
                        break;
                    case 'DTI':
                        this.typeForm = typeFormRequestEnum.DTI;
                        break;
                        
                }
            }
        })
    }

    private get isSead() {
        return this.orgao?.OR_Descricao.includes("SECRETARIA DE ADMINISTRAÇÃO");
    }

    public get isSemurb() {
        return this.orgao?.OR_Descricao.includes("SECRETARIA DE MEIO AMBIENTE E URBANISMO") || 
        this.localStorageService.get<any>('user-data-solicitacao')?.SOL_CodigoOrgao == 3;
    }

    private toggleFields(enable: boolean, fields: string[]) {
        fields.forEach(field => {
            const control = this.form.get(field);
            if (control) {
                if (enable) {
                    control.enable();
                }
                else {
                    control.disable();
                }
            }
        });
    }

    private validatorRuleProcuracao(control): ValidationErrors | null {
        const procuracao = control.get("procuracao").value;
        const isTriagem = control.get("isTriagem").value;
        const check = control.get("checkAnotherApplicant").value;
        const tipoRepresentante = control.get("requerente").get("SOLR_TipoInscricao").value == 3;

        if (procuracao.length == 0 && !isTriagem && !tipoRepresentante && check) {
            return { required: true };
        }

        return null
    }

    validatorOrgaoFiscalizacao(control: AbstractControl): Observable<ValidationErrors | null> {
        const cnpj = control.get("requerente").get("SOLR_CpfCnpj").value;
        const orgaoFiscalizacao = control.get("requerente").get("SOLR_TipoRepresentante").value;

        if (orgaoFiscalizacao != 3) return new Observable<null>((subscriber) => {
            subscriber.next(null);
            subscriber.complete();
        });
    
        if (!cnpj || cnpj.trim() === '') {
          return new Observable<null>((subscriber) => {
            subscriber.next(null);
            subscriber.complete();
          });
        }
    
        return this.oversightOrganizationService.getCnpjOrgaoFiscalizador(cnpj).pipe(
          map((response: any) => {
            return response.ORFI_Cnpj ? null : { invalidOrgaoFiscalizacao: true };
          }),
          catchError(() => {
            return new Observable<ValidationErrors>((subscriber) => {
              subscriber.next({ response: true }); 
              subscriber.complete();
            });
          })
        );
    };

    public get canShowJuridicaOption(): boolean {
        const user = this.global.user();
        
        const isInTriagemGroup = user.GRP_Descricao === 'TRIAGEM';
        
        const triagemOpenPJ = user.USR_AbrirSolicitacaoPJ;
    
        return !isInTriagemGroup || triagemOpenPJ;
    }

    public selectDynamicPgm() {
        this.organizationService.listAll(`"OR_Descricao" = 'PROCURADORIA GERAL DO MUNICÍPIO'`, 0).subscribe((res: { data: any[] }) => {
            const org = res?.data?.[0];
            this.procuradoriaCodigo = org?.OR_CodigoOrgao ?? null;

            this.form.get('solicitacao.SOL_CodigoOrgao')?.valueChanges.subscribe(value => {
                if (this.procuradoriaCodigo && Number(value) === Number(this.procuradoriaCodigo)) {
                    this.isDisabled = false;
                    this.showOrgaoFiscalizador = true;
                    this.form.get('checkAnotherApplicant')?.setValue(true);
                    this.requerenteFormGroup.get('SOLR_TipoInscricao').setValue('3');
                    this.form.get('requerente.SOLR_CpfCnpj')?.setValue('');
                    this.form.get('requerente.SOLR_NomeRazaoSocial')?.setValue('');
                    this.form.get('requerente.SOLR_Email')?.setValue('');
                    this.form.get('requerente.SOLR_Telefone')?.setValue('');
                    this.form.updateValueAndValidity();
                    this.updateMask();
                }
                else {
                    this.isDisabled = true;
                    this.showOrgaoFiscalizador = false;
                    this.form.updateValueAndValidity();
                    this.updateMask();
                }
            });
        });
    }

    public listOrganAndSubjects() {
        this.organizationService.listOrganAndSubjects().subscribe((response) =>{
            this.listOrganizations = response.data;
        });
    }

    private get refisControl() {
        return this.form.get("refisPeriod");
    }

    verifyRulesForUserTriagem() {
        const user = this.global.user();
        
        if (this.userService.isTriagem()) {
            this.isDisabled = true;
            this.toggleActiveFields();

            if (!user.USR_AbrirSolicitacaoPJ) {
                this.textCheckboxRepresentationPerson = "QUERO REPRESENTAR UMA PESSOA FÍSICA";
                this.requerenteFormGroup.get("SOLR_TipoInscricao").patchValue(TypePersonRequestEnum.FISICA);
                this.requerenteFormGroup.get("SOLR_TipoInscricao").disable();
                this.form.updateValueAndValidity();
            }
        }        
    }

    // ------------------------------------------------------------------
    // CATÁLOGO DE SERVIÇOS
    // ------------------------------------------------------------------

    public loadCatalog(): void {
        this.catalogLoading = true;
        this.catalogError = false;

        this.requestService.listServiceCatalog().subscribe({
            next: (response) => {
                const servicos = response?.data || [];

                // A triagem só abre solicitações para o próprio órgão.
                this.catalog = (this.userService.isTriagem()
                    ? servicos.filter((servico) => Number(servico.AS_CodigoOrgao) === Number(this.user.USR_CodigoOrgao))
                    : servicos
                ).map((servico) => ({ ...servico, OR_Curto: orgaoCurto(servico.OR_Descricao) }));

                this.catalogOrgaos = this.buildCatalogOrgaos(this.catalog);
                this.catalogLoading = false;
                this.refreshCatalog();
            },
            error: () => {
                this.catalogLoading = false;
                this.catalogError = true;
            },
        });
    }

    public setCatalogQuery(query: string): void {
        this.catalogQuery = query || '';
        this.refreshCatalog();
    }

    public setCatalogOrgao(orgaoId: number | null): void {
        this.catalogOrgao = orgaoId;
        this.refreshCatalog();
    }

    /** Recalcula os grupos só quando a busca ou o filtro mudam, e não a cada ciclo da tela. */
    public refreshCatalog(): void {
        const termos = this.normalize(this.catalogQuery).split(' ').filter(Boolean);
        const doOrgao = this.catalog.filter(
            (servico) => this.catalogOrgao === null || Number(servico.AS_CodigoOrgao) === this.catalogOrgao,
        );

        if (termos.length) {
            const encontrados = doOrgao
                .map((servico) => ({ servico, nome: this.normalize(servico.AS_Descricao) }))
                .filter(({ servico, nome }) => {
                    const texto = `${nome} ${this.normalize(servico.OR_Sigla)} ${this.normalize(servico.OR_Descricao)}`;
                    return termos.every((termo) => texto.includes(termo));
                })
                // Nome que começa pela busca primeiro; depois os mais procurados.
                .sort((a, b) => {
                    const inicioA = a.nome.startsWith(termos[0]) ? 0 : 1;
                    const inicioB = b.nome.startsWith(termos[0]) ? 0 : 1;
                    return inicioA - inicioB || b.servico.procura - a.servico.procura;
                })
                .map(({ servico }) => servico);

            this.catalogGroups = encontrados.length ? [{ key: 'busca', title: '', items: encontrados }] : [];
            this.catalogResultCount = encontrados.length;
            this.popularServices = [];
            return;
        }

        const grupos = new Map<number, IServiceGroup>();

        for (const servico of doOrgao) {
            const id = Number(servico.AS_CodigoOrgao);

            if (!grupos.has(id)) {
                grupos.set(id, { key: String(id), title: servico.OR_Descricao, items: [] });
            }

            grupos.get(id).items.push(servico);
        }

        this.catalogGroups = Array.from(grupos.values());
        this.catalogResultCount = doOrgao.length;
        this.popularServices =
            this.catalogOrgao === null && !this.userService.isTriagem()
                ? [...this.catalog]
                      .filter((servico) => servico.procura > 0)
                      .sort((a, b) => b.procura - a.procura)
                      .slice(0, POPULAR_SERVICES)
                : [];
    }

    /** Serviço já escolhido, com o que o catálogo sabe dele (prazo, documentos). */
    public get selectedService(): IServiceCatalogItem | null {
        const assuntoId = Number(this.solicitacaoFormGroup.get('SOL_CodigoAssunto').value);

        return assuntoId ? this.catalog.find((servico) => Number(servico.AS_CodigoAssunto) === assuntoId) || null : null;
    }

    public get showCatalogList(): boolean {
        return !this.selectedService || this.changingService;
    }

    /**
     * Escolher um serviço é escolher o órgão e o assunto de uma vez. Quando o órgão muda,
     * as regras dele (SEAD, SEMURB, PGM) precisam valer para o assunto, então o assunto só
     * é aplicado depois que o órgão termina de carregar.
     */
    public selectService(servico: IServiceCatalogItem): void {
        const orgaoId = Number(servico.AS_CodigoOrgao);
        const assuntoId = Number(servico.AS_CodigoAssunto);
        const orgaoControl = this.solicitacaoFormGroup.get('SOL_CodigoOrgao');
        const assuntoControl = this.solicitacaoFormGroup.get('SOL_CodigoAssunto');

        this.changingService = false;

        // Troca manual de serviço: os anexos enviados eram do assunto anterior.
        if (Number(assuntoControl.value) !== assuntoId) {
            this.onSubjectChange();
        }

        if (Number(orgaoControl.value) === orgaoId && Number(this.orgao?.OR_CodigoOrgao) === orgaoId) {
            assuntoControl.setValue(assuntoId);
            return;
        }

        assuntoControl.setValue(null, { emitEvent: false });
        orgaoControl.setValue(orgaoId);
        this.listAssuntoByOrgao(orgaoId, () => assuntoControl.setValue(assuntoId));
    }

    public orgIcon(descricao: string): string {
        return orgIcon(descricao);
    }

    public trackByService(_: number, servico: IServiceCatalogItem): number {
        return servico.AS_CodigoAssunto;
    }

    public trackByGroup(_: number, grupo: IServiceGroup): string {
        return grupo.key;
    }

    /** Por que ainda não dá para sair da etapa do serviço; null quando dá. */
    public get servicePendingReason(): string | null {
        if (this.loadingSubject) return 'Carregando as informações do serviço…';
        if (this.solicitacaoFormGroup.invalid) return 'Escolha o serviço para continuar.';
        if (this.refisControl.invalid) return 'Este serviço não está disponível agora. Escolha outro.';

        return null;
    }

    private buildCatalogOrgaos(servicos: IServiceCatalogItem[]) {
        const orgaos = new Map<number, { id: number; sigla: string; nome: string; descricao: string; total: number }>();

        for (const servico of servicos) {
            const id = Number(servico.AS_CodigoOrgao);
            const orgao = orgaos.get(id) || {
                id,
                sigla: servico.OR_Sigla,
                nome: servico.OR_Curto || servico.OR_Sigla,
                descricao: servico.OR_Descricao,
                total: 0,
            };

            orgao.total++;
            orgaos.set(id, orgao);
        }

        return Array.from(orgaos.values()).sort((a, b) => a.nome.localeCompare(b.nome));
    }

    private normalize(texto: string): string {
        return (texto || '')
            .normalize('NFD')
            .replace(/[̀-ͯ]/g, '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();
    }

    // ------------------------------------------------------------------
    // PARA QUEM É A SOLICITAÇÃO
    // ------------------------------------------------------------------

    /** O cidadão está abrindo a solicitação em nome de outra pessoa ou empresa. */
    public get representing(): boolean {
        return !this.isDisabled;
    }

    /** Triagem sempre representa alguém; na PGM, o requerente é o órgão fiscalizador. */
    public get representationLocked(): boolean {
        return this.userService.isTriagem() || this.isProcuradoria;
    }

    private get isProcuradoria(): boolean {
        const orgao = this.solicitacaoFormGroup.get('SOL_CodigoOrgao').value;

        return !!this.procuradoriaCodigo && Number(orgao) === Number(this.procuradoriaCodigo);
    }

    public setRepresenting(value: boolean): void {
        if (value === this.representing || this.representationLocked) return;

        // A procuração só vale para quem representa: voltando para "Para mim", ela sai,
        // e o upload aparece vazio de novo se o cidadão mudar de ideia.
        if (!value) {
            (this.form.get('procuracao') as FormArray).clear();
        }

        this.form.get('checkAnotherApplicant').setValue(value);
        this.toggleActiveFields();
    }

    /** SOLR_TipoInscricao como texto: o controle guarda ora '2', ora 2. */
    public get tipoInscricao(): string {
        const value = this.requerenteFormGroup.get('SOLR_TipoInscricao').value;

        return value === null || value === undefined ? '' : String(value);
    }

    public setTipoInscricao(value: '1' | '2' | '3'): void {
        const control = this.requerenteFormGroup.get('SOLR_TipoInscricao');

        if (control.disabled || this.tipoInscricao === value) return;

        control.setValue(value);
        control.markAsTouched();
        this.updateMask();
    }

    /** Sem telefone no cadastro, o cidadão informa um aqui (PE_Telefone). */
    public get phoneMissing(): boolean {
        return !this.user?.PE_Telefone1 && !this.userService.isTriagem();
    }

    public get userInitials(): string {
        const partes = String(this.user?.PE_Nome || '').trim().split(/\s+/).filter(Boolean);

        return ((partes[0]?.[0] || '') + (partes.length > 1 ? partes[partes.length - 1][0] : '')).toUpperCase();
    }

    public controlInvalid(path: string): boolean {
        const control = this.form.get(path);

        return !!control && control.invalid && (control.touched || control.dirty);
    }

    /** Por que ainda não dá para sair da etapa "para quem"; null quando dá. */
    public get applicantPendingReason(): string | null {
        if (!this.form.invalid) return null;

        if (this.servicePendingReason) return this.servicePendingReason;
        if (this.form.get('PE_Telefone')?.invalid) return 'Informe seu telefone para contato.';

        if (this.representing) {
            const requerente = this.requerenteFormGroup;

            if (!this.tipoInscricao) return 'Escolha o tipo de pessoa que você representa.';
            if (requerente.get('SOLR_TipoInscricao').hasError('invalidCnpj')) {
                return 'O CNPJ informado não consta como órgão fiscalizador.';
            }
            if (requerente.invalid) return 'Preencha os dados de quem você representa.';
            if (this.form.hasError('required')) return 'Anexe a procuração para continuar.';
            if (this.form.get('termoCiente')?.invalid) return 'Aceite o termo de ciência para continuar.';
        }

        return 'Revise os campos destacados para continuar.';
    }
}
